/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetOrderFinalQtyCommand } from '../../models/set-order-final-qty-command';
import { SetOrderFinalQtyCommandResult } from '../../models/set-order-final-qty-command-result';

export interface ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Params {
      body?: SetOrderFinalQtyCommand
}

export function apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SetOrderFinalQtyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetOrderFinalQtyCommandResult>;
    })
  );
}

apiNurseryManagerOrderDetailsSetOrderDetailsApproveQtyPost.PATH = '/api/NurseryManager/OrderDetails/SetOrderDetailsApproveQty';
